import { render, staticRenderFns } from "./MediaFolderCard.vue?vue&type=template&id=233c8f82&"
import script from "./MediaFolderCard.vue?vue&type=script&lang=ts&"
export * from "./MediaFolderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports